import { useEffect, useState } from "react";
import { ShoppingBag, Menu, X } from "lucide-react";
import { useCart } from "../../context/CartContext";
import logoBadge from "../../assets/logo_badge.png";

const LINKS = [
  { label: "Pickles", href: "#pickles" },
  { label: "Our Promise", href: "#promise" },
  { label: "Her Story", href: "#story" },
  { label: "Order", href: "#order" },
];

export const Nav = () => {
  const { count, setDrawerOpen } = useCart();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-500 ${
        scrolled ? "bg-[#F9F6F0]/85 backdrop-blur-xl border-b border-[#E8E3DA]" : "bg-transparent"
      }`}
    >
      <nav className="mx-auto max-w-[1400px] px-5 md:px-10 h-20 flex items-center justify-between">
        <div className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className={`text-sm tracking-wide transition-colors hover:text-[#B83A14] ${
                scrolled ? "text-[#3D352F]" : "text-[#1E1A17]"
              }`}
            >
              {l.label}
            </a>
          ))}
        </div>

        <a href="#top" data-testid="nav-brand-logo" className="md:absolute md:left-1/2 md:-translate-x-1/2 flex items-center gap-2.5 leading-none">
          <img src={logoBadge} alt="Mamta's Kitchen logo" className="h-11 w-11 md:h-12 md:w-12 object-contain shrink-0" />
          <span className="flex flex-col">
            <span className="font-serif text-2xl md:text-[26px] tracking-tight text-[#1E1A17]">Mamta's Kitchen</span>
            <span className="text-[9px] md:text-[10px] uppercase tracking-[0.35em] text-[#B83A14] mt-0.5">Ghaziabad · Est. Home</span>
          </span>
        </a>

        <div className="flex items-center gap-3">
          <button
            data-testid="open-cart-button"
            aria-label="Open basket"
            onClick={() => setDrawerOpen(true)}
            className="relative p-2 rounded-full hover:bg-[#F2EBE1] transition-colors"
          >
            <ShoppingBag className="h-5 w-5 text-[#1E1A17]" />
            {count > 0 && (
              <span
                data-testid="cart-count-badge"
                className="absolute -top-0.5 -right-0.5 bg-[#B83A14] text-white text-[10px] h-4 min-w-4 px-1 rounded-full flex items-center justify-center"
              >
                {count}
              </span>
            )}
          </button>
          <button
            className="md:hidden p-2"
            aria-label="Menu"
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen((o) => !o)}
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </nav>

      {open && (
        <div className="md:hidden bg-[#F9F6F0] border-b border-[#E8E3DA] px-5 py-4 flex flex-col gap-3">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="text-[#3D352F] py-1"
              data-testid={`mobile-nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
            >
              {l.label}
            </a>
          ))}
        </div>
      )}
    </header>
  );
};
